import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
let token = {
	state: {
		token: 'VrMakerToken',
		// isLogin: false,
	},
	mutations: {
		setToken: (state, token) => {
			state.token = token
			// state.isLogin = true
		}
	},
	actions: {},
	getters: {},

}
export default new Vuex.Store({
	state: {},
	mutations: {

	},
	actions: {},

	modules: {token	}
})